const SOUND_FILES = {
  startup: "/sounds/startup.wav",
  shutdown: "/sounds/shutdown.wav",
  error: "/sounds/error.wav"
};

const cache = {};

const isEnabled = () => {
  try {
    return window.localStorage.getItem("soundEnabled") !== "false";
  } catch (_) {
    return true;
  }
};

const get = name => {
  if (!SOUND_FILES[name]) return null;
  if (!cache[name]) {
    const url = (process.env.PUBLIC_URL || "") + SOUND_FILES[name];
    const audio = new Audio(url);
    audio.preload = "auto";
    cache[name] = audio;
  }
  return cache[name];
};

export const playSound = (name, { force = false } = {}) => {
  if (!force && !isEnabled()) return;
  const audio = get(name);
  if (!audio) return;
  try {
    audio.currentTime = 0;
    const p = audio.play();
    if (p && p.catch) p.catch(() => {});
  } catch (_) {}
};
